module.exports = __webpack_public_path__ + "img/hr-white-desert-bush-14.f1016372.png";